import { Injectable } from '@angular/core';
import { Breakpoint } from '../types/breakpoint';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class BreakpointProviderService {
  private readonly entries = new Map<Breakpoint, string>([
    ['sm', '(min-width: 640px)'],
    ['md', '(min-width: 768px)'],
    ['lg', '(min-width: 1024px)'],
    ['xl', '(min-width: 1280px)'],
    ['2xl', '(min-width: 1536px)'],
    ['max-sm', 'not all and (min-width: 640px)'],
    ['max-md', 'not all and (min-width: 768px)'],
    ['max-lg', 'not all and (min-width: 1024px)'],
    ['max-xl', 'not all and (min-width: 1280px)'],
    ['max-2xl', 'not all and (min-width: 1536px)'],
  ]);

  public size(breakpoint: Breakpoint): string {
    const entry = this.entries.get(breakpoint);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The breakpoint entry for "${breakpoint}" not found.`,
      );
    }

    return entry;
  }
}
